"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
var OutcomeOption_1 = __importDefault(require("./OutcomeOption"));
var Outcome = /** @class */ (function (_super) {
    __extends(Outcome, _super);
    function Outcome(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = {
            value: state.data.outcome,
            error: state.error.outcome,
        };
        _this._isMounted = false;
        form_store_1.default.on("STATE_CHANGE", function () {
            var state = form_store_1.default.getState();
            if (_this._isMounted) {
                _this.setState({
                    value: state.data.outcome,
                    error: state.error.outcome,
                });
            }
        });
        return _this;
    }
    Outcome.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    Outcome.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    Outcome.prototype.render = function () {
        var _a = this.state, value = _a.value, error = _a.error, errorElem = react_1.default.createElement(react_1.default.Fragment, null);
        if (error.length > 0) {
            errorElem = react_1.default.createElement("p", { className: "form-error" }, error[0]);
        }
        var labels = ["出産（生産）", "出産（死産）", "流産（22週未満）", "子宮外妊娠", "子宮内外同時妊娠", "胞状奇胎", "人工中絶", "減胎手術"];
        var formElems = labels.map(function (label, key) {
            return (react_1.default.createElement("li", { key: key, className: "input-list__item" },
                react_1.default.createElement("label", { className: "input-checkbox" },
                    react_1.default.createElement("input", { className: "input-checkbox__input", type: "checkbox", name: "outcome", value: key + 1, checked: value.indexOf("".concat(key + 1)) != -1, onChange: input_actions_1.default.changeInput }),
                    react_1.default.createElement("span", { className: "input-checkbox__text" }, label)),
                (function () {
                    if (key === 6 || key === 7) {
                        return react_1.default.createElement(OutcomeOption_1.default, { number: key + 1 });
                    }
                })()));
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("p", { className: "form__note" }, "\u5F53\u3066\u306F\u307E\u308B\u3082\u306E\u5168\u3066\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"),
            react_1.default.createElement("ul", { className: "input-list input-list--vertical" }, formElems)));
    };
    return Outcome;
}(react_1.Component));
exports.default = Outcome;
